var _jsxFileName = "/media/data/Sandbox/soapbox-defake/app/soapbox/pages/home-page.tsx";
import React, { useRef } from 'react';
import { Link } from 'react-router-dom';
import FeedCarousel from 'soapbox/features/feed-filtering/feed-carousel';
import LinkFooter from 'soapbox/features/ui/components/link-footer';
import { WhoToFollowPanel, TrendsPanel, SignUpPanel, PromoPanel, FundingPanel, CryptoDonatePanel, BirthdayPanel, CtaBanner, AnnouncementsPanel } from 'soapbox/features/ui/util/async-components';
import { useAppSelector, useOwnAccount, useFeatures, useSoapboxConfig } from 'soapbox/hooks';
import Avatar from '../components/avatar';
import { Card, CardBody, Layout } from '../components/ui';
import ComposeForm from '../features/compose/components/compose-form';
import BundleContainer from '../features/ui/containers/bundle-container'; // import GroupSidebarPanel from '../features/groups/sidebar_panel';

const HomePage = _ref => {
  let {
    children
  } = _ref;
  const me = useAppSelector(state => state.me);
  const account = useOwnAccount();
  const features = useFeatures();
  const soapboxConfig = useSoapboxConfig();
  const composeBlock = useRef(null);
  const hasPatron = soapboxConfig.extensions.getIn(['patron', 'enabled']) === true;
  const hasCrypto = typeof soapboxConfig.cryptoAddresses.getIn([0, 'ticker']) === 'string';
  const cryptoLimit = soapboxConfig.cryptoDonatePanel.get('limit', 0);
  const acct = account ? account.acct : '';
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Layout.Main, {
    className: "pt-3 sm:pt-0 dark:divide-gray-800 space-y-3",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 41,
      columnNumber: 7
    }
  }, me && /*#__PURE__*/React.createElement(Card, {
    variant: "rounded",
    ref: composeBlock,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 43,
      columnNumber: 11
    }
  }, /*#__PURE__*/React.createElement(CardBody, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 44,
      columnNumber: 13
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-start space-x-4",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 45,
      columnNumber: 15
    }
  }, /*#__PURE__*/React.createElement(Link, {
    to: "/@".concat(acct),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 46,
      columnNumber: 17
    }
  }, /*#__PURE__*/React.createElement(Avatar, {
    account: account,
    size: 46,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 47,
      columnNumber: 19
    }
  })), /*#__PURE__*/React.createElement(ComposeForm, {
    id: "home",
    shouldCondense: true,
    autoFocus: false,
    clickableAreaRef: composeBlock,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 50,
      columnNumber: 17
    }
  })))), features.feedUserFiltering && /*#__PURE__*/React.createElement(FeedCarousel, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 61,
      columnNumber: 40
    }
  }), children, !me && /*#__PURE__*/React.createElement(BundleContainer, {
    fetchComponent: CtaBanner,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 66,
      columnNumber: 11
    }
  }, Component => /*#__PURE__*/React.createElement(Component, {
    key: "cta-banner",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 67,
      columnNumber: 27
    }
  }))), /*#__PURE__*/React.createElement(Layout.Aside, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 72,
      columnNumber: 7
    }
  }, !me && /*#__PURE__*/React.createElement(BundleContainer, {
    fetchComponent: SignUpPanel,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 74,
      columnNumber: 11
    }
  }, Component => /*#__PURE__*/React.createElement(Component, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 75,
      columnNumber: 27
    }
  })), me && features.announcements && /*#__PURE__*/React.createElement(BundleContainer, {
    fetchComponent: AnnouncementsPanel,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 79,
      columnNumber: 11
    }
  }, Component => /*#__PURE__*/React.createElement(Component, {
    key: "announcements-panel",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 80,
      columnNumber: 27
    }
  })), features.trends && /*#__PURE__*/React.createElement(BundleContainer, {
    fetchComponent: TrendsPanel,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 84,
      columnNumber: 11
    }
  }, Component => /*#__PURE__*/React.createElement(Component, {
    limit: 5,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 85,
      columnNumber: 27
    }
  })), hasPatron && /*#__PURE__*/React.createElement(BundleContainer, {
    fetchComponent: FundingPanel,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 89,
      columnNumber: 11
    }
  }, Component => /*#__PURE__*/React.createElement(Component, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 90,
      columnNumber: 27
    }
  })), hasCrypto && cryptoLimit > 0 && /*#__PURE__*/React.createElement(BundleContainer, {
    fetchComponent: CryptoDonatePanel,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 94,
      columnNumber: 11
    }
  }, Component => /*#__PURE__*/React.createElement(Component, {
    limit: cryptoLimit,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 95,
      columnNumber: 27
    }
  })), /*#__PURE__*/React.createElement(BundleContainer, {
    fetchComponent: PromoPanel,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 98,
      columnNumber: 9
    }
  }, Component => /*#__PURE__*/React.createElement(Component, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 99,
      columnNumber: 25
    }
  })), features.birthdays && /*#__PURE__*/React.createElement(BundleContainer, {
    fetchComponent: BirthdayPanel,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 102,
      columnNumber: 11
    }
  }, Component => /*#__PURE__*/React.createElement(Component, {
    limit: 10,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 103,
      columnNumber: 27
    }
  })), me && features.suggestions && /*#__PURE__*/React.createElement(BundleContainer, {
    fetchComponent: WhoToFollowPanel,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 107,
      columnNumber: 11
    }
  }, Component => /*#__PURE__*/React.createElement(Component, {
    limit: 3,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 108,
      columnNumber: 27
    }
  })), /*#__PURE__*/React.createElement(LinkFooter, {
    key: "link-footer",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 111,
      columnNumber: 9
    }
  })));
};

export default HomePage;